import * as React from "react";
import getConfig from "next/config";
import { useBloomreachReservationBlock, useBloomreachPageRoutes } from "@grandvisionhq/bloomreach";
import { ClickAndReserveGlobalProvider, ClickAndReserve } from "@grandvisionhq/fun-click-and-reserve";
import { useProductWithAFrameData } from "@grandvisionhq/fun-products";
const { publicRuntimeConfig } = getConfig();
const siteName = publicRuntimeConfig?.site.name || "";
const ClickAndReserveContainer = ({ Form, ...props }) => {
  const { displayPrice, activeVariant } = useProductWithAFrameData();
  const confirmationNextSteps = useBloomreachReservationBlock();
  const { routes } = useBloomreachPageRoutes();
  return /* @__PURE__ */ React.createElement(
    ClickAndReserveGlobalProvider,
    {
      Form,
      confirmationNextSteps,
      opco: siteName,
      routes
    },
    /* @__PURE__ */ React.createElement(ClickAndReserve, { product: { activeVariant, displayPrice }, ...props })
  );
};
export {
  ClickAndReserveContainer
};
//# sourceMappingURL=ClickAndReserveContainer.js.map
